module.exports = "<p>\n  renewal-approval-form works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/recovery/renewal-approval/renewal-approval-form/renewal-approval-form.component.html
// module id = ./src/app/recovery/renewal-approval/renewal-approval-form/renewal-approval-form.component.html
// module chunks = main